import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = [ "pick-up-address" ]
  static targets = [ "recommended" ]

  connect() {
    this.pickUpAddressOutlet.element.addEventListener("turbo:frame-render", (event) => {
      const addressUpdated = event.detail.fetchResponse.redirected == true

      if (event.target.id == "pick_up_address" || addressUpdated) {
        const frame = this.recommendedTarget

        if (!frame.hasAttribute("busy")) {
          frame.reload()
        } else if (addressUpdated) {
          frame.loaded.then(() => frame.reload())
        }
      }
    })
  }
}
